import { ZiggyVue } from 'ziggy';
import { Ziggy } from 'ziggy';
import { createApp } from 'vue';
// import * as Vue from 'vue'
// window.Vue = require('vue').default;

let app=createApp({})

window.Vue = app;

require('./components');
app.component('employer-invoices-index', require('./components/EmployerInvoicesIndex.vue').default);

app.use(ZiggyVue, Ziggy);

app.mount("#app")
